export default __webpack_public_path__ + "static/media/time.ff62dc89.png";